

















import { computed, defineComponent, PropType } from 'vue-demi';
import { AdInfo, CardInfo } from '../../type';
import { windowHelper } from '@tencent/ppd-base-libs';

export default defineComponent({
  name: 'MallAdCard',
  components: {},
  props: {
    data: {
      type: Object as PropType<AdInfo & CardInfo>,
      required: true,
    },
  },
  setup(props, context) {
    const imgurl = computed(() => props.data.imgUrl || '');

    function handleClick() {
      const { jumpUrl } = props.data;
      windowHelper.redirect(jumpUrl, 300);
    }

    return {
      imgurl,
      handleClick,
    };
  },
});
